<template lang='pug'>
div
  .panel.panel-default.card(:style="{borderColor: color}")
    .panel-heading(:style="{backgroundColor: color}")
      | {{satisfaction("score")}} {{title}}
      i.fa.fa-3x.pull-right.card-icon(v-bind:class='icon')
    .panel-body.card-body
      slot
      i.fa.fa-spinner.fa-spin.fa-4x.card-spinner(v-if="loading && !custom")
      div(v-else-if='!custom')
        .rating-box(:style="{color: color}" v-if='score > 0')
          .rating(:style="{color: color, width: width('score')}")
        .scale-score(v-if='score > 0' :style="{color: color}") {{score_value("score")}}
        .scale-score(v-else style='font-size: 1.2em; line-height: 2.5em'): i
          | {{$t('js.award.no_data')}}
        .scale-title {{subtitle}}
        .full_time.text-muted(v-if='full_time > 0')
          .rating-box.full-time-rating
            .rating(:style="{width: width('full_time')}")
          | {{ $t('js.award.full_time', {count: score_value("full_time")}) }}
</template>

<script>
import CardBody from './CardBody.vue';

export default {
  components: { CardBody },
  props: ['color', 'title', 'icon', 'type', 'values', 'subtitle', 'custom', 'scale', 'textcolor', 'prefix', 'id'],
  data() {
    return {
      loading: false,
      full_time: 0,
      score: 0,
    }
  },
  computed: {
  },
  mounted() {
    this.fetch()
  },
  methods: {
    width(type) {
      if (this.scale) {
        return `${this[type] / 5 * 100}%`
      } else {
        return `${this[type]}%`
      }
    },
    score_value(type) {
      if (this.scale) {
        const intl = new Intl.NumberFormat(this.$i18n.locale, { maximumFractionDigits: 1 })
        return intl.format(this[type])
      } else {
        const intl = new Intl.NumberFormat(this.$i18n.locale, { style: 'percent' })
        return intl.format(this[type] / 100)
      }
    },
    satisfaction(value) {
      let score = this[value]
      if (!this.scale) {
        score = score / 100 * 5
      }
      let prefix = ""
      if (this.$i18n.locale === "de" && this.prefix) {
        prefix = this.prefix
      }
      if (score >= 4.7) {
        return `${this.$t('js.award.satisfaction.best')}${prefix}`
      } else if (score >= 3.7) {
        return `${this.$t('js.award.satisfaction.very_good')}${prefix}`
      } else if (score >= 2.7) {
        return `${this.$t('js.award.satisfaction.good')}${prefix}`
      } else {
        return ""
      }
    },
    fetch() {
      if (!this.custom) {
        this.loading = true
        this.$http.get(`/award/${this.id}/chart?chart_type=${this.type}`).then((response) => {
          this.loading = false
          this.full_time = response.data.data.full_time
          this.score = response.data.data.score
          this.$emit('input', response.data.data.score)
        })
      }
    },
  },
}
</script>

<style scoped>
  .rating-box {
    position:relative;
    vertical-align: middle;
    font-size: 2.5em;
    font-family: "Font Awesome 5 Free";
    display:inline-block;
    float: left;
    margin-right: 15px;
    color: #777777;
  }
  .full-time-rating{
    font-size: 1em;
    margin-right: 5px;
  }
  .rating-box:before{
    content: "\f005 \f005 \f005 \f005 \f005";
  }
  .rating-box .rating {
    position: absolute;
    left:0;
    top:0;
    white-space:nowrap;
    color: #777777;
    overflow: hidden;
  }
  .rating-box .rating:before {
    content: "\f005 \f005 \f005 \f005 \f005";
    font-weight: 900;
  }
  .full_time{
    margin-top: 20px;
  }
  .card-spinner{
    margin: 20px;
  }
  .scale-title{
    font-size: 20px;
    margin-top: 10px;
  }
  .scale-score{
    font-size: 2.5em;
  }
  .card-body{
    min-height: 180px;
  }
  .card-icon{
    font-size: 30px;
    position: relative;
    top: -5px;
  }
  .card{
    box-shadow: none;
  }
  .panel-heading{
    color: #fff;
    hyphens: auto;
    font-size: 16px;
    font-weight: 700;
  }
  @media only screen and (max-width: 1450px) and (min-width: 1200px) {
    .card-icon{
      display: none;
    }
  }
</style>
